import superAdmin from './super_admin'

export default superAdmin
